import { render } from "./OrientationOverlay.vue?vue&type=template&id=11d5ab22&scoped=true"
import script from "./OrientationOverlay.vue?vue&type=script&lang=js"
export * from "./OrientationOverlay.vue?vue&type=script&lang=js"

import "./OrientationOverlay.vue?vue&type=style&index=0&id=11d5ab22&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d5ab22"]])

export default __exports__